import React from 'react';
import { Link } from 'react-router-dom';

export type KpiTone = 'neutral' | 'good' | 'warn' | 'bad';

export interface Kpi {
  label: string;
  value: React.ReactNode;
  tone?: KpiTone;
  /** Klick fuehrt dorthin (z. B. gefilterte Liste). */
  to?: string;
  hint?: string;
}

const TONE_CLASS: Record<KpiTone, string> = {
  neutral: '',
  good: 'kennzahl-gut',
  warn: 'kennzahl-warn',
  bad: 'kennzahl-schlecht',
};

/**
 * Kennzahlenband, wie es die Firmenakte schon hatte -- jetzt eine Komponente
 * fuer alle Vertriebsseiten, mit optionalem Link je Kachel.
 */
export const KpiRow: React.FC<{ items: Kpi[]; 'aria-label'?: string }> = ({ items, 'aria-label': ariaLabel }) => (
  <div className="akte-kennzahlen kpi-row" role="list" aria-label={ariaLabel ?? 'Kennzahlen'}>
    {items.map((k) => {
      const inner = (
        <>
          <span>{k.value}</span>
          {k.label}
          {k.hint && <small className="kpi-hint">{k.hint}</small>}
        </>
      );
      const cls = `kennzahl ${TONE_CLASS[k.tone ?? 'neutral']}`;
      return k.to ? (
        <Link key={k.label} to={k.to} className={`${cls} kennzahl--link`} role="listitem" title={`Zu: ${k.label}`}>
          {inner}
        </Link>
      ) : (
        <div key={k.label} className={cls} role="listitem">{inner}</div>
      );
    })}
  </div>
);

export default KpiRow;
